module.exports = __webpack_public_path__ + "park_3.834473afa06b97517a60097f509c1a1c.jpg";